import React from "react";
import { FaChevronDown } from "react-icons/fa";

import TechniqueCard from "./TechniqueCard";

export default function TechniquesGrid({
  techniques = [],
  favorites = [],
  hasMore,
  total,
  onLoadMore,
  onOpen,
  onToggleFavorite,
  userId,
}) {
  return (
    <>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
        {techniques.map((technique) => (
          <TechniqueCard
            key={technique.id}
            technique={technique}
            isFavorite={favorites.includes(technique.id)}
            canFavorite={!!userId}
            onToggleFavorite={() => onToggleFavorite(technique.id)}
            onOpen={() => onOpen(technique)}
          />
        ))}
      </div>

      {hasMore && (
        <div className="mt-6 flex justify-center">
          <button
            type="button"
            onClick={onLoadMore}
            className="inline-flex items-center gap-2 rounded-2xl bg-[#013E8E] px-5 py-3 text-sm font-bold text-white shadow-sm transition hover:bg-indigo-800"
          >
            Afficher plus
            <span className="rounded-full bg-white/20 px-2 py-0.5 text-xs">
              {techniques.length}/{total}
            </span>
            <FaChevronDown />
          </button>
        </div>
      )}
    </>
  );
}